import FormaPagoServices from "@/services/FormaPagoServices";

import { bool } from "yup";
//this.$store.state.user.users,current_page
export const fPago = {
    namespace:true,
    state: {fPagos:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListFpago({commit},pageNumber){
            return await FormaPagoServices.getlist(pageNumber).then(
                response=>{    
                    commit('setFpagos',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListFpago({commit},search){          
            return await FormaPagoServices.getSearch(search).then (
                response =>{                    
                    commit('setFpagos',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setFpagos(state,data){
        state.fPagos = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.fPagos.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};